import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import 'numeral/locales/it';
import numeral from 'numeral';
import TriangleComponent from './TriangleComponent';
import ShowComponent from '../hocs/ShowComponent';

numeral.locale('it');

@ShowComponent
class MortageLoanpartsDifferenceToolTipComponent extends React.Component {
  render() {
    const {
      loanparts,
    } = this.props;

    const loanpartRows = loanparts.map((loanpart, index) => (
      <li key={loanpart}>
        Leningdeel {index + 1}
        <span
          className="mortgage-loanparts-difference__tooltip-amount bold"
        >
          € {numeral(loanpart).format('0,0[.]00')}
        </span>
      </li>
    ));

    const loanpartsTotal = _.sum(loanparts.map(lp => Number(lp)));

    return (
      <div className="mortgage-loanparts-difference__tooltip">
        <TriangleComponent
          classNames={'mortgage-loanparts-difference__tooltip-triangle'}
        />

        <ul className="mortgage-loanparts-difference__tooltip-loanparts">
          <li>
            <span className="bold">Gewenste hypotheek </span>
            <span className="mortgage-loanparts-difference__tooltip-amount bold">
              € {numeral(this.props.mortgage).format('0,0[.]00')}
            </span>
          </li>
          {loanpartRows}
          <li className="mortgage-loanparts-difference__tooltip-sum bold">
           Totaal
            <span className="mortgage-loanparts-difference__tooltip-amount bold">
              € {numeral(loanpartsTotal).format('0,0[.]00')}
            </span>
          </li>
        </ul>
      </div>
    );
  }
}

MortageLoanpartsDifferenceToolTipComponent.propTypes = {
  mortgage: PropTypes.number,
  loanparts: PropTypes.arrayOf(PropTypes.number),
};

MortageLoanpartsDifferenceToolTipComponent.defaultProps = {
  mortgage: 0,
  loanparts: [],
};

export default MortageLoanpartsDifferenceToolTipComponent;
